<template>
  <div class="exam-question-default-card w-100">
    <div
      class="avatar avatar-square avatar_sm_md overflow-hidden skeleton-loader"
    ></div>

    <div class="wrapper w-100">
      <div class="line-one rounded-5 skeleton-loader"></div>
      <div class="line-two rounded-5 skeleton-loader"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExamQuestionDefaultCard",
};
</script>

<style lang="scss" scoped>
.exam-question-default-card {
  background: rgba(#ffffff, 0.6);
  @include flex_row_start_nowrap;
  border-radius: 5px;
  padding: 14px 15px;
  margin-bottom: 7px;

  .avatar {
    margin-right: 15px;
  }

  .line-one {
    width: 80%;
    height: 18px;
    margin-bottom: 7px;
  }

  .line-two {
    width: 50%;
    height: 14px;
  }
}
</style>
